import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles(() => ({
	root: {
		backgroundColor: 'white',
		padding: '12px 16px',
		minWidth: 'unset',
	},

	/*
	 * A card, not a solid green bar. The check carries the success; the
	 * sentence stays dark so it reads on the sign-in photo and on a white page.
	 */
	success: {
		backgroundColor: '#fff',
		color: '#1C1C1F',
		padding: '12px 14px',
		minWidth: 280,
		borderRadius: 12,
		border: '1px solid #E6E6EE',
		boxShadow: '0 12px 28px rgba(17, 24, 39, 0.16)',

		'& .message': {
			color: '#1C1C1F !important',
			fontWeight: '600 !important',
			fontSize: 14,
			lineHeight: 1.35,
		},

		'& svg path': {
			stroke: '#157A32',
		},

		'& button': {
			color: '#6B6B76',
		},

		'& button svg path': {
			fill: '#6B6B76',
			stroke: 'none',
		},
	},

	action: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		color: 'black',
		padding: '0',

		'& .message': {
			fontWeight: 400,
			color: '#333335',
		},
	},
}))
